module.exports = __webpack_public_path__ + "img/security.81d5dc08.svg";